import { createSlice } from '@reduxjs/toolkit';
import { SortingRule } from 'react-table';
import { Record } from '../editor/record.types';
import { RecordFilters } from '../tasks/types';
import * as Reducers from './reducers';

export interface IssuesState {
  filters: RecordFilters,
  issuesViewType: string,
  lastRecord: Record<any> | null,
  openEditor: boolean,
  selectedRecord: Record<any> | null,
  resetFilters: boolean,
  paintMapPins: number,
  snackbarID: string,
  sortingInstructions: SortingRule<object>[];
}

export const initialState: IssuesState = {
  filters: {
    globalFilter: '',
    filters: undefined,
  },
  issuesViewType: 'list',
  lastRecord: null,
  openEditor: false,
  selectedRecord: null,
  resetFilters: false,
  paintMapPins: 0,
  snackbarID: '',
  sortingInstructions: [],
};

export const issuesSlice = createSlice({
  name: 'issues',
  initialState,
  reducers: {
    setFilters: (state, action) => Reducers.filtersReducer(state, action),
    setIssuesViewType: (state, action) => Reducers.issuesViewTypeReducer(state, action),
    setLastRecord: (state, action) => Reducers.lastRecordReducer(state, action),
    setOpenEditor: (state, action) => Reducers.openEditorReducer(state, action),
    setSelectedRecord: (state, action) => Reducers.selectedRecordReducer(state, action),
    setResetFilters: (state, action) => Reducers.resetFiltersReducer(state, action),
    setPaintMapPins: (state, action) => Reducers.paintMapPinsReducer(state, action),
    setSnackbarID: (state, action) => Reducers.snackbarIDReducer(state, action),
    setSortingInstructions: (state, action) => Reducers.sortingInstructionsReducer(state, action),
  },
});

export const {
  setFilters,
  setIssuesViewType,
  setLastRecord,
  setOpenEditor,
  setSelectedRecord,
  setResetFilters,
  setPaintMapPins,
  setSnackbarID,
  setSortingInstructions,
} = issuesSlice.actions;

export default issuesSlice.reducer;
